import React from "react";
import styles from "./SkinHealthHome.module.scss";
import style from "./LayoutCards.module.scss";
import ProductSelector from "../../../static/images/home_cards/product-selector.svg";
import WoundManagement from "../../../static/images/home_cards/wound-management.svg";
import RiskAssessment from "../../../static/images/home_cards/risk-assessment.png";
import ClinicalResources from "../../../static/images/home_cards/clinical-resources.svg";
import Formulary from "../../../static/images/home_cards/formulary.svg";

const mapCardIcon = {
  "Product Selector": ProductSelector,
  "Wound Management": WoundManagement,
  "Risk Assessment": RiskAssessment,
  "Clinical Resources": ClinicalResources,
  Formulary: Formulary,
};

export const LayoutCards = ({ loading, layoutDetails, images, onLoad, onCard }) => {
  return (
    <div className={style.inline_cards_section}>
      <div className={style.inline_cards}>
        {loading
          ? Array.from({ length: 5 }).map((_, i) => (
              <div key={i} data-testid="loading-skeleton" className={`${style.card_box} ${styles.shimmer}`} style={{ width: 250, height: 250 }} />
            ))
          : layoutDetails?.cards?.map((card) => {
              const isImgLoaded = !!images[card?.id];
              return (
                <div key={card?.id} className={`${style.card_box} text-center`} onClick={() => onCard(card?.name)}>
                  {!isImgLoaded && (
                    <div
                      data-testid="card-shimmer"
                      className={style.shimmer}
                      style={{
                        position: "absolute",
                        inset: 0,
                        borderRadius: 6,
                      }}
                    />
                  )}
                  <img
                    src={mapCardIcon[card?.name]}
                    alt={card?.name}
                    onLoad={() => onLoad(card?.id)}
                    onError={() => onLoad(card?.id)}
                    style={{
                      opacity: isImgLoaded ? 1 : 0,
                      transition: "opacity 0.3s ease-in-out",
                    }}
                  />
                  <p style={{ opacity: isImgLoaded ? 1 : 0 }}>{card?.name}</p>
                </div>
              );
            })}
      </div>
    </div>
  );
};
